import * as React from "react";
import ButtonComponent from "components/Button";
import {Avatar, Box, IconButton, Typography} from "@mui/material";
import { H2, H4, H6 } from "components/CustomTypography";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { getLogo } from "helpers/utils";

const PaymentPreview = ({
  isLoading, payment, editPayment, cancelEdit, history,
}) => {
  const { paymentoption, paymentkey, paymentupi, paymentqrcode } = payment;

    const handlePage = (page) => () => {
        history.push({
            pathname: page,
        });
    };


    const renderPayment = (option) => {
        switch(option) {
            case "upibased":
                return (
                    <div>
                        <Typography>
                            <H2>UPI (Direct to shop)</H2>
                            <H4>Enabled</H4>
                        </Typography>

                        <Typography>
                            <H4>UPI ID:</H4>
                            <H4>{`${paymentupi || ""}`}</H4>
                        </Typography>

                        <Box m={2} display="flex" className="position-relative">
                            <Box>
                                <Avatar onClick={handlePage("/myshop/qrcode")} src={getLogo(paymentqrcode)} className="profile-img" />
                                <div className="camera-icon">
                                    <IconButton
                                        color="primary"
                                        aria-label="upload picture"
                                        component="span"
                                        onClick={handlePage("/myshop/qrcode")}
                                        size="large"
                                    >
                                        <PhotoCamera />
                                    </IconButton>
                                </div>
                            </Box>
                        </Box>
                        <hr />
                    </div>

                );

            case "codbased":
                return (
                    <div>
                        <Typography>
                            <H2>Cash on Delivery (CoD)</H2>
                            <H4>Enabled</H4>
                        </Typography>
                        <hr />
                    </div>
                );

            default:
                return (
                    <div></div>
                );

        }
    }

    const renderNoPayment = () => {
        // paymentoption is assumed to be an array now
        return (
            <div>
            <Typography>
                <H2>No payment method setup</H2>
            </Typography>
        </div>
        );
    };


    const renderAllPayments = () => {
        // paymentoption is assumed to be an array now
        return (paymentoption || []).map((option) => renderPayment(option));
    };

  return (
    <Box display="flex">
      <Box overflow="hidden" width="80%" className="p-3">
          {!paymentoption || (paymentoption && Array.isArray(paymentoption) && paymentoption.length === 0) ? renderNoPayment() : renderAllPayments(paymentoption) }
      </Box>
      <Box>
        {!isLoading
              && (
              <ButtonComponent
                sx={{
                  m: 2,
                }}
                variant="contained"
                type="primary"
                name="Edit"
                size="small"
                onClick={editPayment}
              />
              )}
      </Box>
    </Box>
  );
};

export default PaymentPreview;
